import { clubbiStyled } from 'clubbi-ui'

export const StyledLink = clubbiStyled('a')(({ theme }) => ({
  color: theme.palette.brandInfo[60],
  fontWeight: 600,
}))
